module.exports = __webpack_public_path__ + "img/us-quotation-popup-notpi@2x.27c8872e.png";